{
  "journal": {
    "title": "事件日誌",
    "label": "日誌",
    "auto_update": "自動更新事件",
    "error": {
      "generic": "從伺服器檢索新事件時發生錯誤"
    },
    "filter": {
      "application": {
        "any": "全部"
      },
      "event_type": {
        "any": "全部"
      },
      "instance_id": {
        "any": "全部"
      }
    }
  }
}
